import { configureStore } from "@eroad/helpers/redux";

const { sagaMiddleware, store } = configureStore({});

export { sagaMiddleware, store };
